import { useMemo } from 'react';
import { PaymentMethod } from './typing';
import { DEFAULT_METHODS, PAYMENT_METHOD_OPTIONS } from './config';

export default function usePaymentMethods(
  methods: PaymentMethod[] = DEFAULT_METHODS,
): PaymentMethod[] {
  return useMemo<PaymentMethod[]>(() => {
    return methods.filter((item) => {
      const options = PAYMENT_METHOD_OPTIONS[item];
      return options && options.enabled;
    });
  }, [methods]);
}
